// Angular Import
import { Component, Input, inject } from '@angular/core';

import { NavigationEnd, Router, RouterModule, Event } from '@angular/router';
import { Title } from '@angular/platform-browser';

// project import
import { NavigationItem, NavigationItems } from 'src/app/theme/layout/admin/navigation/navigation';
import { SharedModule } from '../../shared.module';

interface titleType {
  // eslint-disable-next-line
  url: string | boolean | any | undefined;
  title: string;
  breadcrumbs: unknown;
  type: string;
}

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterModule, SharedModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  private route = inject(Router);
  private titleService = inject(Title);

  // public props
  @Input() type: string;

  navigations: NavigationItem[];
  breadcrumbList: Array<string> = [];
  navigationList!: titleType[];

  private readonly PAGE_TITLE_MAP: Array<[RegExp, string]> = [
    [/^\/drivers\/add$/, 'Add Driver'],
    [/^\/drivers\/edit\//, 'Edit Driver'],
    [/^\/drivers\/profile\/[^/]+\/edit-vehicle$/, 'Edit Vehicle'],
    [/^\/drivers\/profile\//, 'Driver Profile'],
    [/^\/passengers\/add$/, 'Add Passenger'],
    [/^\/passengers\/edit\//, 'Edit Passenger'],
    [/^\/passengers\/profile\//, 'Passenger Profile'],
    [/^\/passengers\/pulse\//, 'Passenger Pulse'],
    [/^\/system-access\/manage-users\/add$/, 'Add User'],
    [/^\/system-access\/manage-users\/edit\//, 'Edit User'],
    [/^\/system-access\/roles\/add$/, 'Add Role'],
    [/^\/system-access\/roles\/edit\//, 'Edit Role'],
    [/^\/user\/accountProfile\//, 'My Profile'],
    [/^\/managers$/, 'Managers'],
    [/^\/$/, 'Login'],
    [/^\/login$/, 'Login'],
    [/^\/forgetPassword$/, 'Forgot Password'],
  ];

  // constructor
  constructor() {
    this.navigations = NavigationItems;
    this.type = 'icon';
    this.setBreadcrumb();
  }

  // public method
  setBreadcrumb() {
    this.route.events.subscribe((router: Event) => {
      if (router instanceof NavigationEnd) {
        const activeLink = router.url;
        const breadcrumbList = this.filterNavigation(this.navigations, activeLink);
        const title = breadcrumbList[breadcrumbList.length - 1]?.title || this.getTitleFromUrl(activeLink);
        this.navigationList = breadcrumbList.splice(-2);
        this.titleService.setTitle(title + ' | VeloRide Admin');
      }
    });
  }

  private getTitleFromUrl(url: string): string {
    const cleanUrl = url.split('?')[0];
    for (const [pattern, title] of this.PAGE_TITLE_MAP) {
      if (pattern.test(cleanUrl)) return title;
    }
    return 'VeloRide Admin';
  }

  filterNavigation(navItems: NavigationItem[], activeLink: string): titleType[] {
    for (const navItem of navItems) {
      if (navItem.type === 'item' && 'url' in navItem && navItem.url === activeLink) {
        return [
          {
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          }
        ];
      }
      if ((navItem.type === 'group' || navItem.type === 'collapse') && 'children' in navItem) {
        const breadcrumbList = this.filterNavigation(navItem.children!, activeLink);

        if (breadcrumbList.length > 0) {
          breadcrumbList.unshift({
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          });
          return breadcrumbList;
        }
      }
    }
    return [];
  }
}
